import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { StickyAboutSection } from "@/components/home/StickyAboutSection";
import { FeaturedCasesSection } from "@/components/home/FeaturedCasesSection";

export default function Index() {
  return (
    <Layout hideFooter={false} transparentHeader>
      <HeroSection />
      <StickyAboutSection />
      <FeaturedCasesSection />
    </Layout>
  );
}
